import { useEffect, useState } from 'react';
import * as React from 'react';
import { message } from 'antd';
import Icon, { CloseOutlined } from '@ant-design/icons';
import { showAdmin } from '@/utils/user';
import { css } from '@emotion/react';
import companyLogoIcon from '@/assets/icons/company-logo.svg';
import { ReactComponent as help } from '@/home/images/svg/help.svg';
import { ReactComponent as vector } from '@/assets/icons/vector.svg';
import { useUser, useCompanyGroup } from '@/hooks';
import { getEverLoginApp } from './api';
import DownloadModal from '@/components/modal/DownloadModal';
import UserMenu from '@/components/menu/UserMenu';
import { Link } from 'react-router-dom';
import ArcSiteCampaign from './campaign';
// import { useQuery } from 'react-query';
// import { getCompanyInfo } from '@/api';
// import { queryClient } from '@/query_client';

// queryClient.prefetchQuery('companyInfo', getCompanyInfo);

const IntercomWebWidget = () => {
  const onClick = () => {
    if (!window.Intercom) {
      message.error(
        'The help center is not ready yet, please refresh the page and try again'
      );
      return;
    }
    window.Intercom('show');
  };

  return (
    <div
      onClick={onClick}
      className="shrink-0 flex items-center justify-center h-8 w-8 sm:h-12 sm:w-12 rounded box-content cursor-pointer hover:bg-gray-f5f5f5"
    >
      <Icon component={help} className="text-24" />
    </div>
  );
};

const DownloadButton = ({ onClick }: { onClick: () => void }) => {
  const [hiddenDownload, setHiddenDownload] = useState(false);
  const [isEverLoginApp, setEverLoginApp] = useState(true);

  useEffect(() => {
    getEverLoginApp()
      .then(res => {
        setEverLoginApp(res.value);
      })
      .catch(() => {
        setEverLoginApp(false);
      });
  }, []);

  return (
    <>
      {!isEverLoginApp && !hiddenDownload ? (
        <div
          className="bg-gray-f0f0f0 items-center py-2 px-3 gap-2 rounded mr-4 cursor-pointer hidden sm:flex"
          onClick={onClick}
        >
          <Icon component={vector} className="text-16" />
          <span className="text-blue-398AE7 whitespace-nowrap hidden sm:inline-block">
            Download App
          </span>
          <CloseOutlined
            onClick={e => {
              e.stopPropagation();
              setHiddenDownload(true);
            }}
          />
        </div>
      ) : null}
    </>
  );
};

const CompanyLogo = () => {
  const user = useUser();
  const companyGroup = useCompanyGroup();
  return (
    <>
      <Link to="/admin/manage_accnt" className="hidden sm:block">
        <div className="relative border-l-1 border-black-10 cursor-pointer">
          <span
            className={`relative p-3 inline-block hover:after:content-['Edit'] hover:after:absolute hover:after:left-0 hover:after:top-0 
        hover:after:w-full hover:after:h-full hover:after:flex hover:after:items-center hover:after:justify-center 
        hover:after:bg-[rgba(0,0,0,0.6)] hover:after:text-white-96`}
          >
            <img
              height="32"
              className="object-contain"
              src={user?.company_logo_url || companyLogoIcon}
              alt="company logo"
            />
          </span>
        </div>
      </Link>
      {!!companyGroup && (
        <div className="text-black-55 text-10 flex flex-col px-3 border-l-1 border-black-10">
          <span>Managed by</span>
          <span className="font-bold text-12 whitespace-nowrap">
            {companyGroup.name}
          </span>
        </div>
      )}
    </>
  );
};

const MainMenu = () => {
  const user = useUser();
  const isAdmin = showAdmin(user);
  const isCompany = user?.default_org_type === 'COMPANY';
  const [downloadVisiable, setDownloadVisiable] = useState(false);

  if (!user) {
    return null;
  }

  const showDownloadModal = () => {
    setDownloadVisiable(true);
  };

  return (
    <div className="h-full">
      <div className="flex items-center h-full sm:w-auto">
        <DownloadButton onClick={showDownloadModal} />
        <ArcSiteCampaign user={user} />
        {isAdmin && isCompany && <CompanyLogo />}
        <UserMenu user={user as any} onOpenDownloadModal={showDownloadModal} />
        <div className="items-center self-stretch px-2 sm:px-3 border-l border-black-10 hidden sm:flex">
          <IntercomWebWidget />
        </div>
      </div>
      <DownloadModal
        downloadVisiable={downloadVisiable}
        setDownloadVisiable={setDownloadVisiable}
      ></DownloadModal>
    </div>
  );
};

export default MainMenu;
